/* ============================================================================
   ATHLO+ — Membership controller
   ----------------------------------------------------------------------------
   Knows whether the visitor is a signed-in member (set by Liquid on <body>
   data-member), drives the Join slide-in (snippets/hub-join-modal.liquid), and
   gates member-only actions (Save, "I'm in", profile).

     window.HubMember
       .is()                       -> bool (signed-in member)
       .id / .name                 -> customer id / first name (members only)
       .requireMember(reason, cb)  -> runs cb if member, else opens the slide-in
       .openJoin(reason) / .closeJoin()

   The slide-in is a sleek bottom-corner nudge (never a takeover). PROACTIVE
   nudges fire at high-intent moments — after the quiz, while browsing the shop,
   mid/end of a journal, on add-to-cart — at most ONCE per session and not again
   for 3 days after a dismiss. NEVER on immediate entry. Member-only ACTIONS
   (Save / I'm in) open it on demand regardless.
   ========================================================================== */
(function () {
  'use strict';
  var d = document.body || document.documentElement;
  var IS = d.getAttribute('data-member') === 'true';
  var NAME = d.getAttribute('data-member-name') || '';
  var ID = d.getAttribute('data-member-id') || '';
  var modal = null, lastFocus = null;
  var SNOOZE_DAYS = 3;

  var REASONS = {
    intro: "Join ATHLO+ free — your Locker, your archetype and points on every order, all in one place.",
    quiz: "Nice — your archetype is ready. Join free to keep it on your profile and build your Locker.",
    shop: "Enjoying the gear? Members earn points and save favourites to their Locker. Join free.",
    journal: "Like this? Join ATHLO+ free — save reads, clubs and gear to your Locker.",
    cart: "Members earn points & perks on every order. Join free before you check out?",
    save: "Saving is a member perk. Join free to keep clubs, races & venues in your Locker.",
    profile: "Your athlete profile lives in your Locker. Join free to claim it.",
    interest: "Tell the community you’re in — join free to show your interest and find your people.",
    "whats-on": "Members see the whole season on What’s On — plus your sports and a reminder email the day before. Join free."
  };

  function qs(s, r) { return (r || document).querySelector(s); }
  function track(name, detail) {
    try { window.dispatchEvent(new CustomEvent('hub:' + name, { detail: detail || {} })); } catch (e) {}
    if (typeof window.gtag === 'function') window.gtag('event', name, detail || {});
    if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: name }, detail || {}));
  }

  function open(reason) {
    modal = modal || qs('#hub-join');
    if (!modal) return;
    reason = reason || 'intro';
    var txt = REASONS[reason] || REASONS.intro;
    if (reason === 'quiz') { try { var a = JSON.parse(localStorage.getItem('hub:archetype') || 'null'); if (a && a.title) txt = "You’re " + a.title + "! Join free to keep your archetype on your profile and build your Locker."; } catch (e) {} }
    var r = qs('[data-join-reason]', modal); if (r) r.textContent = txt;
    modal.setAttribute('data-reason', reason);
    lastFocus = document.activeElement;
    modal.hidden = false;
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    try { sessionStorage.setItem('hub:join:session', '1'); } catch (e) {}
    track('membership_prompt', { reason: reason });
  }
  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    setTimeout(function () { modal.hidden = true; }, 420);
    try { localStorage.setItem('hub:join:snooze', String(Date.now())); } catch (e) {}
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function requireMember(reason, cb) { if (IS) { if (cb) cb(); return true; } open(reason); return false; }

  // PROACTIVE nudge: respects member state, once-per-session, and a 3-day snooze.
  function snoozed() {
    try {
      if (sessionStorage.getItem('hub:join:session')) return true;
      var t = parseInt(localStorage.getItem('hub:join:snooze') || '0', 10);
      if (t && (Date.now() - t) < SNOOZE_DAYS * 864e5) return true;
    } catch (e) {}
    return false;
  }
  function maybeNudge(reason, delay) {
    if (IS) return;
    if (snoozed()) return;
    setTimeout(function () { if (!snoozed()) open(reason); }, delay || 300);
  }

  function initModal() {
    modal = qs('#hub-join'); if (!modal) return;
    modal.addEventListener('click', function (e) { if (e.target.hasAttribute('data-join-close')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) close(); });
  }

  // ---- High-intent triggers (non-members only) ----
  function quizTrigger() {
    window.addEventListener('hub:quiz', function (e) {
      if (e && e.detail && e.detail.event === 'quiz_complete') maybeNudge('quiz', 1800);
    });
  }
  function cartTrigger() {
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f || !f.action || String(f.action).indexOf('/cart/add') < 0) return;
      maybeNudge('cart', 1100); // non-blocking — cart still adds
    }, true);
  }
  function scrollDepthTrigger(reason, pct) {
    var fired = false;
    function onScroll() {
      if (fired) return;
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      if (max > 0 && (h.scrollTop || window.pageYOffset) / max >= pct) { fired = true; window.removeEventListener('scroll', onScroll); maybeNudge(reason, 400); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  function contextTriggers() {
    var c = (document.body.className || '');
    if (/template-(product|collection|search|list-collections)/.test(c)) {
      scrollDepthTrigger('shop', 0.45);
      setTimeout(function () { maybeNudge('shop'); }, 35000); // or after dwelling 35s
    } else if (/template-article/.test(c)) {
      scrollDepthTrigger('journal', 0.6);
    }
  }

  // NOTE: proactive nudges (quiz / cart / scroll / dwell) are now owned by the
  // email-capture popup (sections/hub-exit-popup.liquid) to avoid double-popups.
  // The slide-in stays for on-demand member gating only (Save / interest / profile).
  // To re-enable auto-nudges, add: quizTrigger(); cartTrigger(); contextTriggers();
  void quizTrigger; void cartTrigger; void contextTriggers;
  function ready() { initModal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();

  window.HubMember = { is: function () { return IS; }, id: ID, name: NAME, requireMember: requireMember, openJoin: open, closeJoin: close };
})();
